import { render } from "./RegionsView.vue?vue&type=template&id=13cd70ee&scoped=true"
import script from "./RegionsView.vue?vue&type=script&lang=js"
export * from "./RegionsView.vue?vue&type=script&lang=js"

import "./RegionsView.vue?vue&type=style&index=0&id=13cd70ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cd70ee"]])

export default __exports__